import { 
	Box, Button, Snackbar, Table, 
	TableBody, TableCell, TableHead, TableRow ,TextField
} from "@material-ui/core"; 
import Autocomplete from '@material-ui/lab/Autocomplete';
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline"; 
import AddBoxIcon from "@material-ui/icons/AddBox"; 
import { makeStyles } from "@material-ui/core/styles"; 
import { exportInvoicePdf } from "../../Components/invoicePdf";
import Alert from "@material-ui/lab/Alert"; 
import Dialog  from "@material-ui/core/Dialog"; 
import DialogActions from "@material-ui/core/DialogActions"; 
import DialogContent from "@material-ui/core/DialogContent"; 
import DialogContentText from "@material-ui/core/DialogContentText"; 
import DialogTitle from "@material-ui/core/DialogTitle";
import TableContainer from '@material-ui/core/TableContainer'; 
import './CheckIn.scss';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import apiClient, { getAccessToken } from '../../apiClient';
import React, { useState, useEffect } from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { useHistory, useLocation } from 'react-router-dom';
import ItemForm from '../ItemForm/ItemForm';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { TableFooter } from '@material-ui/core';
import moment from 'moment';
import Spinner from '../Spinner';
import { publishNotification } from '../Notification/notificationService';
import TransactionHeader from '../../Components/TransactionHeader';

/** Check-in autocomplete: active and inactive items (excludes archived). */
const CHECKIN_ITEM_AUTOCOMPLETE_PARAMS = {
	forAutocomplete: 1,
	autocompleteEligible: 'active_inactive',
};

function checkInItemCatalogRequestConfig(accessToken) {
	return {
		params: { ...CHECKIN_ITEM_AUTOCOMPLETE_PARAMS, _ts: Date.now() },
		headers: {
			Authorization: `Bearer ${accessToken || ''}`,
			'Cache-Control': 'no-cache',
			Pragma: 'no-cache',
		},
	};
}

const useStyles = makeStyles({ 
	root: { 
		"& > *": { 
			borderBottom: "unset", 
		}, 
	},
	customTextField: {
		'& .MuiInputBase-root': {
			backgroundColor: 'transparent',
		},
	},
	
	snackbar: { 
		bottom: "104px", 
	}, 
	table: {
		maxWidth: '100%', // Set to '100%' to make the table responsive
	  },
	  tableHeader: {
		backgroundColor: '#f2f2f2',
		fontWeight: 'bold',
	  },
	  tableRow: {
		'&:hover': {
		  backgroundColor: '#e0e0e0',
		},
	  },
	  tableCell: {
		borderBottom: '1px solid #dddddd',
		width:"150px !important",
	  },
	  tableCellEmbedded: {
		borderBottom: '1px solid #dddddd',
		width: 'auto',
		padding: '6px 8px',
		verticalAlign: 'middle',
	  },
	  tableEmbedded: {
		width: '100%',
		tableLayout: 'fixed',
	  },
	  rowDiv: {
		width:"1000px !important",
	  },
	  dialogCustom:{
		width:"800px !important",
		height:"600px !important",
	  },
	  divRight:{
		float:"right"
	  }
	  ,
	  divLeft:{
		float:"left"
	  }
}); 


function getDefaultLocationIdFromList(list) {
	const hit = (list || []).find(
		(x) =>
			x &&
			(x.IsDefault === 1 ||
				x.IsDefault === true ||
				String(x.IsDefault).toLowerCase() === 'true')
	);
	return hit ? hit.ItemLocationId : '';
}

async function fetchMetricUidForItemLocation(itemId, locationId, accessToken) {
	if (!itemId) return '';
	try {
		const res = await apiClient.get('/api/get/itemmetricuid', {
			params: { itemId },
			headers: { Authorization: `Bearer ${accessToken || ''}` },
		});
		const uidRows = res.data || [];
		if (locationId != null && locationId !== '') {
			const hit = uidRows.find(
				(r) => Number(r.LocationId) === Number(locationId)
			);
			if (hit && String(hit.MetricUID || '').trim()) {
				return String(hit.MetricUID).trim();
			}
		}
		if (uidRows.length === 1) {
			return String(uidRows[0].MetricUID || '').trim();
		}
		return '';
	} catch {
		return '';
	}
}

function resolveReturnLocationIdFromStock(stockRows, locationList, primaryLocationId) {
	const primary = Number(primaryLocationId);
	// Keep the location from the original transaction when present (e.g. PO return).
	if (primary > 0) return primary;

	const ids = (stockRows || [])
		.map((s) => Number(s.LocationId))
		.filter((id) => id > 0);
	if (!ids.length) {
		const def = getDefaultLocationIdFromList(locationList);
		return def === '' || def == null ? '' : Number(def);
	}
	if (ids.length === 1) return ids[0];
	const def = getDefaultLocationIdFromList(locationList);
	if (def !== '' && def != null && ids.includes(Number(def))) return Number(def);
	return ids[0];
}

function ticketRowLocationIdFromTransaction(item, itemDetail, locationCatalog) {
	const locRaw =
		item?.LocationId != null && item.LocationId !== ''
			? item.LocationId
			: getDefaultLocationIdFromList(locationCatalog);
	if (locRaw === '' || locRaw == null) return '';
	const num = Number(locRaw);
	return Number.isNaN(num) || num <= 0 ? '' : num;
}

function buildCheckInLocationAllocations(locationId, qtyRaw, locationCatalog, locationOptions) {
	const qty = parseFloat(qtyRaw) || 0;
	const locId = Number(locationId);
	if (!locId || Number.isNaN(locId) || qty <= 0) return [];
	const hit =
		(locationOptions || []).find((o) => Number(o.LocationId) === locId) ||
		(locationCatalog || []).find((l) => Number(l.ItemLocationId) === locId);
	return [
		{
			locationId: locId,
			locationName: hit?.LocationName || '',
			quantity: qty,
		},
	];
}

function syncCheckInLocationAllocationsToQty(row, qtyRaw, locationCatalog) {
	const qty = parseFloat(qtyRaw) || 0;
	if (!row) return row;
	const next = { ...row };
	const locId =
		next.locationId != null && next.locationId !== ''
			? Number(next.locationId)
			: 0;
	if (!locId || Number.isNaN(locId)) {
		next.locationAllocations = [];
		return next;
	}
	next.locationId = locId;
	next.locationAllocations = buildCheckInLocationAllocations(
		locId,
		qty,
		locationCatalog,
		next.locationOptions
	);
	return next;
}

function syncCheckInLocationAllocationsToLocation(row, newLocationId, qtyRaw, locationCatalog) {
	const next = { ...row };
	const locId = Number(newLocationId);
	const qty = parseFloat(qtyRaw) || 0;
	if (!locId || Number.isNaN(locId)) {
		next.locationId = '';
		next.locationAllocations = [];
		return next;
	}
	next.locationId = locId;
	next.locationAllocations = buildCheckInLocationAllocations(
		locId,
		qty,
		locationCatalog,
		next.locationOptions
	);
	return next;
}

function isCheckInPurchaseOrderEditContext(tranAction, formAction) {
	if (tranAction !== 'edit') return false;
	if (formAction === 'Return') return false;
	return String(tranAction || '').indexOf('return') === -1;
}

function buildCheckInRowFromTransactionItem(item, itemDetail, locationCatalog, rowId) {
	const rowQty = parseFloat(item.Quantity) || 0;
	const rowLocationId = ticketRowLocationIdFromTransaction(
		item,
		itemDetail,
		locationCatalog
	);
	return {
		id: rowId,
		itemid: item.ItemId,
		itemname: item.ItemName,
		qtyinstock: parseFloat(itemDetail?.Quantity) || 0,
		checkoutqty: item?.Quantity,
		checkinqty: item.Quantity,
		returnQuantity: item.ReturnQuantity,
		returnTicketNumber: item.ReturnTicketNumber,
		priperunit: item.PricePerUnit,
		totpri: item.TotalPrice,
		itemnumber: item.ItemNumber,
		targetprice:
			item.TargetPrice != null && item.TargetPrice !== '' ? item.TargetPrice : 0,
		isNonInventory:
			itemDetail &&
			(itemDetail.IsNonInventory === 1 || itemDetail.IsNonInventory === true),
		locationId: rowLocationId,
		locationAllocations: buildCheckInLocationAllocations(
			rowLocationId,
			rowQty,
			locationCatalog,
			[]
		),
		locationOptions: [],
		metricUID: '',
	};
}

function normalizeCheckInRowForSubmit(row, defaultLocationId, locationCatalog) {
	const checkinqty = parseFloat(row.checkinqty) || 0;
	const rawLoc =
		row.locationId != null && row.locationId !== '' && Number(row.locationId) > 0
			? Number(row.locationId)
			: defaultLocationId != null &&
				  defaultLocationId !== '' &&
				  Number(defaultLocationId) > 0
				? Number(defaultLocationId)
				: '';
	let normalized = {
		...row,
		checkinqty,
		locationId: rawLoc,
	};
	if (rawLoc && checkinqty > 0) {
		const existingAllocs = Array.isArray(row.locationAllocations)
			? row.locationAllocations
			: [];
		const allocSum = existingAllocs.reduce(
			(sum, a) => sum + (parseFloat(a.quantity) || 0),
			0
		);
		const hasMultiLocationAllocations =
			existingAllocs.length > 1 &&
			Math.abs(allocSum - checkinqty) < 1e-6;
		if (!hasMultiLocationAllocations) {
			normalized = syncCheckInLocationAllocationsToQty(
				normalized,
				checkinqty,
				locationCatalog
			);
		}
	}
	return normalized;
}

function attachEditLocationsForPurchaseRows(
	rowItems,
	locationCatalog,
	setRows,
	tranAction,
	formAction,
	setOldRows
) {
	if (!isCheckInPurchaseOrderEditContext(tranAction, formAction)) return;
	const applyLocationPatch = (prev, row) => {
		const idx = prev.findIndex((r) => Number(r.itemid) === Number(row.itemid));
		if (idx < 0) return prev;
		const next = [...prev];
		next[idx] = { ...next[idx], ...row.patch };
		return next;
	};
	const user = JSON.parse(sessionStorage.getItem('user') || '{}');
	const accessToken = user.accessToken || '';
	(rowItems || []).forEach((row) => {
		if (!row || !row.itemid) return;
		apiClient
			.get(`/api/get/itemlocationstock`, {
				params: { itemId: row.itemid },
				headers: { Authorization: `Bearer ${accessToken}` },
			})
			.then((res) => {
				const stock = (res.data || []).map((x) => ({
					LocationId: Number(x.LocationId),
					LocationName: x.LocationName,
					Quantity: parseFloat(x.Quantity) || 0,
				}));
				const locId =
					row.locationId ||
					resolveReturnLocationIdFromStock(stock, locationCatalog, row.locationId);
				if (!locId) return;
				const qty = parseFloat(row.checkinqty) || 0;
				const synced = syncCheckInLocationAllocationsToLocation(
					{ ...row, locationOptions: stock },
					locId,
					qty,
					locationCatalog
				);
				const patch = {
					locationId: synced.locationId,
					locationAllocations: synced.locationAllocations,
					locationOptions: stock,
				};
				setRows((prev) => applyLocationPatch(prev, { itemid: row.itemid, patch }));
				if (setOldRows) {
					setOldRows((prev) => applyLocationPatch(prev, { itemid: row.itemid, patch }));
				}
			})
				.catch(() => {
					publishNotification('Unable to load item location stock.', 'error');
				});
	});
}

function attachReturnLocationsForRows(rowItems, locationCatalog, setRows, tranAction, formAction, setOldRows) {
	const isReturnContext =
		(tranAction && String(tranAction).indexOf('return') !== -1) ||
		formAction === 'Return';
	if (!isReturnContext) return;
	const applyLocationPatch = (prev, row) => {
		const idx = prev.findIndex((r) => Number(r.itemid) === Number(row.itemid));
		if (idx < 0) return prev;
		const next = [...prev];
		next[idx] = { ...next[idx], ...row.patch };
		return next;
	};
	const user = JSON.parse(sessionStorage.getItem('user') || '{}');
	const accessToken = user.accessToken || '';
	(rowItems || []).forEach((row) => {
		if (!row || !row.itemid) return;
		apiClient
			.get(`/api/get/itemlocationstock`, {
				params: { itemId: row.itemid },
				headers: { Authorization: `Bearer ${accessToken}` },
			})
			.then((res) => {
				const stock = (res.data || []).map((x) => ({
					LocationId: Number(x.LocationId),
					LocationName: x.LocationName,
					Quantity: parseFloat(x.Quantity) || 0,
				}));
				const locId = resolveReturnLocationIdFromStock(
					stock,
					locationCatalog,
					row.locationId
				);
				if (!locId) return;
				const qty = parseFloat(row.checkinqty) || 0;
				const hit = stock.find((s) => Number(s.LocationId) === Number(locId));
				const patch = {
					locationId: locId,
					locationOptions: stock,
					...(qty > 0
						? {
								locationAllocations: [
									{
										locationId: locId,
										locationName: hit?.LocationName || '',
										quantity: qty,
									},
								],
						  }
						: {}),
				};
				setRows((prev) => applyLocationPatch(prev, { itemid: row.itemid, patch }));
				if (setOldRows) {
					setOldRows((prev) => applyLocationPatch(prev, { itemid: row.itemid, patch }));
				}
			})
				.catch(() => {
					publishNotification('Unable to load return location stock.', 'error');
				});
	});
}

function getCheckInLocationStockQty(locationOptions, locationId) {
	const locId = Number(locationId);
	if (!locId) return 0;
	const hit = (locationOptions || []).find((o) => Number(o.LocationId) === locId);
	return parseFloat(hit?.Quantity) || 0;
}

function sumCheckInOtherLocationStock(locationOptions, attachedLocationId) {
	const attached = Number(attachedLocationId);
	return (locationOptions || []).reduce((sum, o) => {
		const id = Number(o.LocationId);
		if (!id || id === attached) return sum;
		return sum + (parseFloat(o.Quantity) || 0);
	}, 0);
}

function getCheckInLocationName(locationOptions, locationId, locationCatalog) {
	const locId = Number(locationId);
	const hit =
		(locationOptions || []).find((o) => Number(o.LocationId) === locId) ||
		(locationCatalog || []).find((l) => Number(l.ItemLocationId) === locId);
	return hit?.LocationName || `Location ${locId}`;
}

function isCheckInRowNonInventory(row) {
	const v = row?.isNonInventory ?? row?.IsNonInventory;
	return v === true || v === 1 || String(v).toLowerCase() === 'true';
}

async function fetchCheckInRowLocationStock(itemId, accessToken) {
	if (!itemId) return [];
	const res = await apiClient.get(`/api/get/itemlocationstock`, {
		params: { itemId },
		headers: { Authorization: `Bearer ${accessToken}` },
	});
	return (res.data || []).map((x) => ({
		LocationId: Number(x.LocationId),
		LocationName: x.LocationName,
		Quantity: parseFloat(x.Quantity) || 0,
	}));
}

async function validatePurchaseOrderReturnLocationStock(rows, locationCatalog, accessToken) {
	const errors = [];
	const confirmLines = [];

	for (let i = 0; i < (rows || []).length; i++) {
		const row = rows[i];
		if (!row || isCheckInRowNonInventory(row)) continue;

		const returnQty = parseFloat(row.checkinqty) || 0;
		if (returnQty <= 0) continue;

		const maxReturnable = parseFloat(row.checkoutqty) || 0;
		if (maxReturnable > 0 && returnQty > maxReturnable + 1e-6) {
			errors.push(
				`Row ${i + 1}: Return quantity (${returnQty}) cannot exceed the original purchase quantity (${maxReturnable}).`
			);
			continue;
		}

		const attachedLocId = Number(row.locationId);
		if (!attachedLocId) {
			errors.push(`Row ${i + 1}: No location is attached to this purchase line.`);
			continue;
		}

		let options = row.locationOptions || [];
		if (!options.length && row.itemid) {
			options = await fetchCheckInRowLocationStock(row.itemid, accessToken);
		}

		const attachedQty = getCheckInLocationStockQty(options, attachedLocId);
		const locName = getCheckInLocationName(options, attachedLocId, locationCatalog);

		if (returnQty <= attachedQty + 1e-6) continue;

		const otherQty = sumCheckInOtherLocationStock(options, attachedLocId);

		if (otherQty <= 1e-6) {
			errors.push(
				`Row ${i + 1}: Return quantity (${returnQty}) is not available at the attached location "${locName}" (available: ${attachedQty.toFixed(2)}).`
			);
			continue;
		}

		const totalQty = attachedQty + otherQty;
		if (returnQty > totalQty + 1e-6) {
			errors.push(
				`Row ${i + 1}: Return quantity (${returnQty}) is not available at the attached location "${locName}" (available: ${attachedQty.toFixed(2)}).`
			);
			continue;
		}

		const otherNames = (options || [])
			.filter(
				(o) =>
					Number(o.LocationId) !== attachedLocId &&
					(parseFloat(o.Quantity) || 0) > 0
			)
			.map((o) => o.LocationName)
			.filter(Boolean);
		const itemLabel = row.itemnumber || row.itemname || `Item ${i + 1}`;
		confirmLines.push(
			`Row ${i + 1} (${itemLabel}): return quantity ${returnQty.toFixed(2)} exceeds stock at "${locName}" (${attachedQty.toFixed(2)}). The system will use quantity from other location(s)${otherNames.length ? `: ${otherNames.join(', ')}` : ''}.`
		);
	}

	return {
		ok: errors.length === 0,
		errors,
		needsConfirm: confirmLines.length > 0,
		confirmMessage: confirmLines.join('\n'),
	};
}

function buildPurchaseOrderReturnLocationAllocations(returnQty, attachedLocId, locationOptions) {
	const qty = parseFloat(returnQty) || 0;
	const attached = Number(attachedLocId);
	if (!qty || qty <= 0 || !attached) return [];

	let remaining = qty;
	const allocations = [];
	const attachedQty = getCheckInLocationStockQty(locationOptions, attached);
	const fromAttached = Math.min(remaining, attachedQty);
	if (fromAttached > 0) {
		const hit = (locationOptions || []).find((o) => Number(o.LocationId) === attached);
		allocations.push({
			locationId: attached,
			locationName: hit?.LocationName || '',
			quantity: fromAttached,
		});
		remaining -= fromAttached;
	}

	(locationOptions || []).forEach((opt) => {
		if (remaining <= 1e-6) return;
		const locId = Number(opt.LocationId);
		if (!locId || locId === attached) return;
		const avail = parseFloat(opt.Quantity) || 0;
		if (avail <= 0) return;
		const take = Math.min(remaining, avail);
		allocations.push({
			locationId: locId,
			locationName: opt.LocationName || '',
			quantity: take,
		});
		remaining -= take;
	});

	return allocations;
}

function applyOtherLocationReturnAllocations(rows, locationCatalog) {
	return (rows || []).map((row) => {
		if (isCheckInRowNonInventory(row)) return row;
		const returnQty = parseFloat(row.checkinqty) || 0;
		const attachedLocId = Number(row.locationId);
		if (!returnQty || !attachedLocId) return row;

		const options = row.locationOptions || [];
		const attachedQty = getCheckInLocationStockQty(options, attachedLocId);
		if (returnQty <= attachedQty + 1e-6) {
			return syncCheckInLocationAllocationsToQty(row, returnQty, locationCatalog);
		}

		const allocations = buildPurchaseOrderReturnLocationAllocations(
			returnQty,
			attachedLocId,
			options
		);
		if (!allocations.length) return row;
		return {
			...row,
			locationId: attachedLocId,
			locationAllocations: allocations,
		};
	});
}

function attachMetricUidForPurchaseRows(rowItems, setRows, tranAction) {
	if (tranAction && String(tranAction).indexOf('return') !== -1) return;
	const user = JSON.parse(sessionStorage.getItem('user') || '{}');
	const accessToken = user.accessToken || '';
	if (!rowItems || !rowItems.length) return;
	Promise.all(
		rowItems.map((row, index) =>
			fetchMetricUidForItemLocation(row.itemid, row.locationId, accessToken).then((uid) => ({
				index,
				uid,
			}))
		)
	).then((results) => {
		setRows((prev) => {
			const next = [...prev];
			results.forEach(({ index, uid }) => {
				if (next[index]) {
					next[index] = { ...next[index], metricUID: uid };
				}
			});
			return next;
		});
	});
}
  

function CheckIn(props) { 

	const embeddedInDialog = props.embeddedInDialog === true;
	const history = useHistory();
	const location = useLocation();
    const pathname = location.pathname;
	const pageName = pathname.substring(1);
	
	const contentRef = React.createRef();
    const gridRef = React.createRef();
	const [apiVendorData, setApiVenderData] = useState([]);
	const [apiItemData, setApiItemData] = useState([]);
	const [apiLocationData, setApiLocationData] = useState([]);
	const [successMessage, setSuccessMessage] = useState(null);
	const [errorMessage, setErrorMessage] = useState(null);

	const [fullWidth] = React.useState(true);
	const [isAdded, setIsAdded] = React.useState(false);
  const [maxWidth] = React.useState('lg');
  const [userName, setUserName] = React.useState('');

  const [showTranDetail, setshowTranDetail] = React.useState(false);
  const [tranDetail, settranDetail] = React.useState([]);
  const [fullWidthTrans] = React.useState(true);
  const [maxWidthTrans] = React.useState('md');
  const [rowIndex, setRowIndex] = React.useState(0);
  const [, setVendorName] = React.useState('');
  const [tranEdit]  = React.useState(props.tranDetail);
  const [tranAction]  = React.useState(props.action);
  const [loading, setloading] = React.useState(false);
   

	useEffect(() => {
	  const fetchData = async () => {
		try {
		 
		 
		  
		  let user = JSON.parse(sessionStorage.getItem('user'));
        setUserName(user.userName);

		  let accessToken = getAccessToken();
		  sessionStorage.setItem('TranSearch', null);
		  sessionStorage.setItem('ItemTabIndex', JSON.stringify(0));
		  apiClient.get(`/api/get/vendor`, { headers: {"Authorization" : `Bearer ${accessToken}`} })
		  .then(res => {
			const vendorList = res.data;
			setApiVenderData(vendorList);
			setVendorName((apiVendorData.filter(x=>x.VendorId == formData.vendorId)[0])?.VendorName);
		  });

		  let locationCatalog = [];

		   if(user.permissions.filter(x=>x.PermissionName == 'InTake Product' && x.PermissionAllowed == 1).length == 0)
         {
            history.replace('/home');
            return;
         }

		  const [locRes, itemRes] = await Promise.all([
			apiClient.get(`/api/get/itemlocation`, { headers: { Authorization: `Bearer ${accessToken}` } }),
			apiClient.get(`/api/get/item`, checkInItemCatalogRequestConfig(accessToken)),
		  ]);
		  locationCatalog = locRes.data || [];
		  setApiLocationData(locationCatalog);
		  const itemList = itemRes.data || [];
		  setApiItemData(itemList);

			if(tranEdit != null)
			{
				var items = [];
				var olditems = [];
				var total = 0;
				var totalQty = 0;
				var formData = {
					date: null,
					action:'',
					vendorId: 0,
					ticketNumber: '',
					reason:''
			};
			if(tranEdit.TicketNumber.includes('OUT'))
			{
                formData.action = 'CheckOut';
			}
			else if(tranEdit.TicketNumber.includes('CHK'))
			{
				formData.action = 'CheckIn';
			}
			else if(tranEdit.TicketNumber.includes('RET'))
			{
				formData.action = 'Return';
			}
			else if(tranEdit.TicketNumber.includes('RES'))
			{
				formData.action = 'Reserve';
			}
			else if(tranEdit.TicketNumber.includes('ADJ'))
			{
				formData.action = 'Adjustment';
			}
				tranEdit.items.forEach(function(item){
					var itemDetail = itemList.filter(x=>x.ItemNumber == item.ItemNumber)[0];
					const baseRow = buildCheckInRowFromTransactionItem(
						item,
						itemDetail,
						locationCatalog,
						rows.length + 1
					);
					formData.date = moment(item.Date);
					formData.vendorId = item.VendorId;
					formData.reason = item.Reason;
					formData.ticketNumber = item.TicketNumber;
					formData.vendorName = item.VendorName;
					formData.returnTicketNumber = item.ReturnTicketNumber;
					formData.user = item.UserName;
					
					items.push(baseRow);
					total += item.TotalPrice;
					if (!isNonInventoryRow(itemDetail)) {
						totalQty += toQty(item.Quantity);
					}
					olditems.push(JSON.parse(JSON.stringify(baseRow)));
				});
				setformData(formData);
				setRows(items); 		
				setOldRows(olditems);
				setEdit(true); 
				attachReturnLocationsForRows(items, locationCatalog, setRows, tranAction, formData.action, setOldRows);
				attachEditLocationsForPurchaseRows(
					items,
					locationCatalog,
					setRows,
					tranAction,
					formData.action,
					setOldRows
				);
				attachMetricUidForPurchaseRows(items, setRows, tranAction);
				
		
		          setGrandTotal(total);
				  setTotalQty(totalQty);	
			}

		} catch (error) {
		  console.error('Error fetching data:', error);
		}
	  };
  
	  fetchData();
	}, [history]);
  
	const classes = useStyles();
	const tableCellClass = embeddedInDialog ? classes.tableCellEmbedded : classes.tableCell;
	const tableClassName = embeddedInDialog
		? `${classes.table} ${classes.tableEmbedded}`
		: classes.table;

	const [formData, setformData] = useState({
            date: new Date(),
			action: '',
            vendorId: null,
			reason: '',
    });

	const [rows, setRows] = useState([]);
	
	const [oldRows, setOldRows] = useState([]);

	const [open, setOpen] = React.useState(false); 
	const [grandTotal, setGrandTotal] = React.useState(0); 
	const [totalQty, setTotalQty] = React.useState(0); 
	const [isEdit, setEdit] = React.useState(false); 
	const [, setDisable] = React.useState(true);
	const [showConfirm, setShowConfirm] = React.useState(false);
	const [showReturnLocationConfirm, setShowReturnLocationConfirm] = React.useState(false);
	const [returnLocationConfirmMessage, setReturnLocationConfirmMessage] = React.useState('');
	const [pendingReturnRows, setPendingReturnRows] = React.useState(null); 
	const [showAddItem, setAddItem] = React.useState(false); 
	const getDefaultLocationId = () => getDefaultLocationIdFromList(apiLocationData);

	
	const handleClose = (event, reason) => { 
		if (reason === "clickaway") { 
			return; 
		} 
		setOpen(false); 
	}; 

	const handleDateChange = (value) => { 
		
		formData['date'] = value;
        setformData({
            date: formData.date,
			action: formData.action,
            vendorId: formData.vendorId,
			reason: formData.reason,
		    vendorName: formData.vendorName,
			user:formData.user,
			returnTicketNumber:formData.returnTicketNumber,
    });
	}; 

	// Non-inventory items should not contribute to Purchase Order Total Quantity.
	const isNonInventoryRow = (row) => {
		const rowItemId = row?.itemid ?? row?.ItemId;
		if (rowItemId != null && rowItemId !== '') {
			const matchedItem = apiItemData.find(
				(item) => Number(item?.ItemId) === Number(rowItemId)
			);
			if (matchedItem) {
				const itemFlag = matchedItem.IsNonInventory;
				return (
					itemFlag === true ||
					itemFlag === 1 ||
					String(itemFlag).toLowerCase() === 'true'
				);
			}
		}
		const v = row?.isNonInventory ?? row?.IsNonInventory ?? row?.isNoninventory;
		return v === true || v === 1 || String(v).toLowerCase() === 'true';
	};

	const toQty = (value) => {
		const n = Number.parseFloat(value);
		return Number.isFinite(n) ? n : 0;
	};

	const checkInEditStockMsg =
		'There is not sufficient quantity in stock. Please adjust the quantity.';

	const sameGridItem = (a, b) => {
		if (!a || !b) return false;
		if (a.itemid && b.itemid && String(a.itemid) === String(b.itemid)) return true;
		const an = a.itemnumber != null ? String(a.itemnumber) : '';
		const bn = b.itemnumber != null ? String(b.itemnumber) : '';
		return an !== '' && an === bn;
	};

	const sameGridItemLocation = (a, b) => {
		if (!sameGridItem(a, b)) return false;
		const la = Number(a?.locationId) || 0;
		const lb = Number(b?.locationId) || 0;
		return la === lb;
	};

	const shouldValidateCheckInEditStock = () =>
		isCheckInPurchaseOrderEditContext(tranAction, formData.action);

	/** Stock available to reverse at the PO line's linked location (not total item qty). */
	const getEditLocationStockForRow = (row) => {
		const locId = Number(row?.locationId);
		if (locId && Array.isArray(row?.locationOptions) && row.locationOptions.length > 0) {
			return getCheckInLocationStockQty(row.locationOptions, locId);
		}
		return toQty(row?.qtyinstock);
	};

	const checkInEditStockMsgForRow = (row, available) => {
		const locId = Number(row?.locationId);
		if (locId) {
			const locName = getCheckInLocationName(
				row?.locationOptions,
				locId,
				apiLocationData
			);
			const avail = Number.isFinite(available)
				? available
				: getEditLocationStockForRow(row);
			return `There is not sufficient quantity in stock at location "${locName}" (available: ${avail.toFixed(2)}). Please adjust the quantity.`;
		}
		return checkInEditStockMsg;
	};

	const sumOldCheckInForSameItemLocation = (refRow) => {
		let s = 0;
		(oldRows || []).forEach((r) => {
			if (sameGridItemLocation(refRow, r)) {
				s += toQty(r.checkinqty != null ? r.checkinqty : r.checkoutqty);
			}
		});
		return s;
	};

	const minCheckInQtyForEditRow = (rowList, refRow) => {
		if (isNonInventoryRow(refRow)) return 0;
		const stock = getEditLocationStockForRow(refRow);
		const oldSum = sumOldCheckInForSameItemLocation(refRow);
		const othersNew = (rowList || []).reduce((sum, r) => {
			if (r === refRow || !sameGridItemLocation(refRow, r)) return sum;
			return sum + toQty(r.checkinqty);
		}, 0);
		return Math.max(0, oldSum - stock - othersNew);
	};

	const clampCheckInQtyToStock = (rowList, index) => {
		const row = rowList[index];
		if (!row || (!row.itemid && !row.itemnumber)) return { clamped: false };
		if (isNonInventoryRow(row)) return { clamped: false };
		const qty = parseFloat(row.checkinqty);
		if (Number.isNaN(qty)) return { clamped: false };
		const stock = getEditLocationStockForRow(row);
		const minQty = minCheckInQtyForEditRow(rowList, row);
		if (qty + 1e-6 >= minQty) return { clamped: false };
		row.checkinqty = minQty;
		row.totpri = toQty(row.priperunit) * minQty;
		return { clamped: true, message: checkInEditStockMsgForRow(row, stock) };
	};

	const validateAllCheckInEditStock = (rowList) => {
		if (!shouldValidateCheckInEditStock()) return { ok: true };
		const seen = new Set();
		for (let i = 0; i < rowList.length; i++) {
			const row = rowList[i];
			if (!row || (!row.itemid && !row.itemnumber)) continue;
			if (isNonInventoryRow(row)) continue;
			const itemKey = row.itemid ? `id:${row.itemid}` : `n:${row.itemnumber}`;
			const locKey = Number(row.locationId) || 0;
			const key = `${itemKey}|loc:${locKey}`;
			if (seen.has(key)) continue;
			seen.add(key);
			const oldSum = sumOldCheckInForSameItemLocation(row);
			const newSum = (rowList || []).reduce(
				(sum, r) => sum + (sameGridItemLocation(row, r) ? toQty(r.checkinqty) : 0),
				0
			);
			const stock = getEditLocationStockForRow(row);
			if (oldSum - newSum > stock + 1e-6) {
				return { ok: false, message: checkInEditStockMsgForRow(row, stock) };
			}
		}
		const removedOld = (oldRows || []).filter((oldRow) => {
			if (!oldRow || (!oldRow.itemid && !oldRow.itemnumber)) return false;
			if (isNonInventoryRow(oldRow)) return false;
			return !(rowList || []).some((r) => sameGridItemLocation(oldRow, r));
		});
		for (let i = 0; i < removedOld.length; i++) {
			const oldRow = removedOld[i];
			const oldSum = sumOldCheckInForSameItemLocation(oldRow);
			const stock = getEditLocationStockForRow(oldRow);
			if (oldSum > stock + 1e-6) {
				return { ok: false, message: checkInEditStockMsgForRow(oldRow, stock) };
			}
		}
		return { ok: true };
	};

	const flashCheckInStockError = (message) => {
		setErrorMessage(message || checkInEditStockMsg);
		setTimeout(() => setErrorMessage(null), 5000);
	};

	const getTotalQuantity= () =>{
		
		var totalQty = 0;
		if(tranDetail.length != 0){
			 tranDetail.items.forEach(element => {
		   if (!isNonInventoryRow(element)) {
				totalQty += toQty(element.checkinqty);
		   }
		 });
		}
		
	   return parseFloat(totalQty)?.toFixed(2);
	   };


	   const getTotalQuantityEditMode= () =>{
		var total = 0;
		if(rows != null && rows.length > 0){
			rows.forEach((r) => {
				if(!isNonInventoryRow(r)) {
					total += toQty(r.checkinqty);
				}
			});
		}
		return parseFloat(total)?.toFixed(2);
	   };
	   
	const handleAdd = () => { 
		setIsAdded(true);
		setRows([ 
			...rows, 
			{ 
				id: rows.length + 1,  
				itemid: '',itemname:'', qtyinstock: 0,checkinqty:0 ,priperunit:0,totpri:0,itemnumber:'',targetprice:0
				,isNonInventory:false,locationId:getDefaultLocationId(),locationAllocations:[],locationOptions:[],metricUID:''
			}, 
		]); 
		setEdit(true); 
	}; 

	

	  const targetPriceFromItem = (item) => {
		if (!item) return 0;
		const tp = item.TargetPrice != null ? item.TargetPrice : item.targetPrice;
		return tp != null && tp !== '' ? tp : 0;
	  };

	  const recomputeTotalsFromList = (list) => {
		var total = 0;
		var totalQty = 0;
		list.forEach(function (item) {
			total += parseFloat(item.totpri) || 0;
			if (!isNonInventoryRow(item)) {
				totalQty += toQty(item.checkinqty);
			}
		});
		setGrandTotal(total);
		setTotalQty(totalQty);
	  };

	  const isItemGridOptionInactive = (option) => {
		if (option == null || typeof option !== 'object') return false;
		const a = option.Active;
		return (
			a === false ||
			a === 0 ||
			String(a).toLowerCase() === 'false' ||
			String(a) === '0'
		);
	  };

	  const getItemGridOptionLabel = (option) => {
		if (option == null) return '';
		const num = option.ItemNumber != null ? String(option.ItemNumber) : '';
		const name = option.ItemName != null ? String(option.ItemName) : '';
		const base = num && name ? `${num} — ${name}` : num || name;
		if (!base) return '';
		return isItemGridOptionInactive(option) ? `${base} (Inactive)` : base;
	  };

	  const filterItemGridOptions = (options, state) => {
		const q = (state.inputValue || '').toLowerCase().trim();
		if (!q) return options;
		return options.filter((o) => {
			const num = String(o.ItemNumber != null ? o.ItemNumber : '').toLowerCase();
			const name = String(o.ItemName != null ? o.ItemName : '').toLowerCase();
			return num.includes(q) || name.includes(q);
		});
	  };

	  const findExactGridItemMatch = (input, options) => {
		const q = String(input || '').trim().toLowerCase();
		if (!q) return null;
		return (
			(options || []).find((o) => {
				const num = String(o.ItemNumber != null ? o.ItemNumber : '').toLowerCase();
				const name = String(o.ItemName != null ? o.ItemName : '').toLowerCase();
				return num === q || name === q;
			}) || null
		);
	  };

	  const applyCheckInGridItem = (list, index, item) => {
		list[index]['qtyinstock'] = toQty(item?.Quantity);
		list[index]['itemname'] = item.ItemName;
		list[index]['itemnumber'] = item.ItemNumber;
		list[index]['itemid'] = item.ItemId;
		list[index]['targetprice'] = targetPriceFromItem(item);
		list[index]['locationId'] = getDefaultLocationId();
		list[index]['isNonInventory'] =
			item.IsNonInventory === 1 || item.IsNonInventory === true;
		const defaultLoc = getDefaultLocationId();
		const qty = parseFloat(list[index].checkinqty) || 0;
		if (defaultLoc && qty > 0) {
			Object.assign(
				list[index],
				syncCheckInLocationAllocationsToLocation(
					list[index],
					defaultLoc,
					qty,
					apiLocationData
				)
			);
		} else {
			list[index]['locationAllocations'] = [];
		}
		return syncRowMetricUid(
			list,
			index,
			list[index]['itemid'],
			list[index]['locationId']
		);
	  };

	  const syncRowMetricUid = (list, index, itemId, locationId) => {
		const user = JSON.parse(sessionStorage.getItem('user'));
		const accessToken = user && user.accessToken ? user.accessToken : '';
		return fetchMetricUidForItemLocation(itemId, locationId, accessToken).then((uid) => {
			list[index]['metricUID'] = uid;
			return list;
		});
	  };

	  const handleAutoCompleteChange = (event, index, reason) => {
		if (reason !== 'clear') return;
		const list = [...rows];
		list[index]['itemid'] = 0;
		list[index]['qtyinstock'] = 0;
		list[index]['itemname'] = '';
		list[index]['itemnumber'] = '';
		list[index]['targetprice'] = 0;
		list[index]['isNonInventory'] = false;
		list[index]['metricUID'] = '';
		setRows(list);
	  };

	  const handleAutoCompleteBlur = (event, index) => {
		const itemNumberFromInput =
			event && event.target ? String(event.target.value || '').trim() : '';
		if (!itemNumberFromInput) return;
		const matched = findExactGridItemMatch(itemNumberFromInput, apiItemData);
		if (!matched) return;
		const list = [...rows];
		applyCheckInGridItem(list, index, matched).then((updated) => {
			setRows([...updated]);
			recomputeTotalsFromList(updated);
		});
	  };

	

	  const handleInput2Change = (event, newInputValue, index, reason) => {
		if (reason === 'reset') return;
		const list = [...rows];
		if (pageName == 'transactions') {
			if (newInputValue != '') {
				list[index]['itemnumber'] = newInputValue;
				setRows(list);
			} else if (isAdded) {
				list[index]['itemnumber'] = newInputValue;
				setRows(list);
			}
		} else {
			list[index]['itemnumber'] = newInputValue;
			setRows(list);
		}
	  };


	// The handleInputChange handler can be set up to handle 
	// many different inputs in the form, listen for changes 
	// to input elements and record their values in state 
	const handleInputChange = (e, index) => { 
		setDisable(false); 
		
		const { name, value } = e.target; 
		const list = [...rows]; 
		let value1 = value;
		// Only sanitize dash-prefixed numeric text inputs; keep dropdown values intact.
		if (name === 'itemid' || name === 'priperunit' || name === 'checkinqty' || name === 'targetprice') {
			value1 = typeof value === 'string' ? value.replace(/-/g, '') : value;
		}
		list[index][name] = value1;

		
		if(name == 'itemid')
		{
			let accessToken = getAccessToken();
			const params = {
				itemid:  value1 ,
			  };

			apiClient.get(`/api/get/itembyid`  ,  { params: params ,headers: {"Authorization" : `Bearer ${accessToken}`} })
				.then(res => {
				list[index]['qtyinstock'] = toQty(res.data[0]?.Quantity); 
				list[index]['itemname'] = res.data[0].ItemName; 
				list[index]['itemnumber'] = res.data[0].ItemNumber; 
				list[index]['targetprice'] = targetPriceFromItem(res.data[0]); 
				list[index]['locationId'] = getDefaultLocationId();
				list[index]['isNonInventory'] =
					res.data[0].IsNonInventory === 1 || res.data[0].IsNonInventory === true;
				const defaultLoc = getDefaultLocationId();
				const lineQty = parseFloat(list[index].checkinqty) || 0;
				if (defaultLoc && lineQty > 0) {
					Object.assign(
						list[index],
						syncCheckInLocationAllocationsToLocation(
							list[index],
							defaultLoc,
							lineQty,
							apiLocationData
						)
					);
				}
				syncRowMetricUid(
					list,
					index,
					list[index]['itemid'],
					list[index]['locationId']
				).then((updated) => {
					const next = [...updated];
					if(name == 'priperunit'  )
					{
						next[index]['totpri'] = value1 * next[index]['checkinqty'];
					}
					setRows(next);
					recomputeTotalsFromList(next);
				});
				return;
				})



		}else if (name === 'locationId') {
			const qty = parseFloat(list[index].checkinqty) || 0;
			Object.assign(
				list[index],
				syncCheckInLocationAllocationsToLocation(
					list[index],
					value1,
					qty,
					apiLocationData
				)
			);
			setRows(list);
			syncRowMetricUid(
				list,
				index,
				list[index]['itemid'],
				value1
			).then((updated) => {
				setRows([...updated]);
			});
			return;
		}else{

			if(name == 'priperunit' || name =='checkinqty')
		{
			list[index]['totpri'] = list[index]['priperunit'] * list[index]['checkinqty'];
			if (
				name === 'checkinqty' &&
				(isCheckInPurchaseOrderEditContext(tranAction, formData.action) ||
					tranEdit == null)
			) {
				Object.assign(
					list[index],
					syncCheckInLocationAllocationsToQty(
						list[index],
						list[index].checkinqty,
						apiLocationData
					)
				);
			}
			if (name === 'checkinqty' && shouldValidateCheckInEditStock()) {
				const parsedQty = parseFloat(list[index].checkinqty);
				if (!Number.isNaN(parsedQty)) {
					const { clamped, message } = clampCheckInQtyToStock(list, index);
					if (clamped) {
						flashCheckInStockError(message);
						Object.assign(
							list[index],
							syncCheckInLocationAllocationsToQty(
								list[index],
								list[index].checkinqty,
								apiLocationData
							)
						);
					}
				}
			}
		}

		if(name == 'targetprice')
		{
			const tp = parseFloat(value1);
			list[index]['targetprice'] = Number.isFinite(tp) ? tp : 0;
		}

		setRows(list); 
		recomputeTotalsFromList(list);

		}

        
		
	}; 

	// Showing delete confirmation to users 
	const handleConfirm = (index) => { 
		setShowConfirm(true); 
		setRowIndex(index);
	}; 

	const handleAddItem = () => { 
		setAddItem(true); 
	};

	
 const   generatePdf = () => {
	exportInvoicePdf({
	  element: contentRef.current,
	  gridElement: gridRef.current,
	});

  };



	// Handle the case of delete confirmation where 
	// user click yes delete a specific row of id:i 
	const handleRemoveClick = (i) => { 
		const list = [...rows]; 
		let listNew = list.filter(x=>x.id !== (rowIndex)); 
		const editStockRes = validateAllCheckInEditStock(listNew);
		if (!editStockRes.ok) {
			setShowConfirm(false);
			flashCheckInStockError(editStockRes.message);
			return;
		}
		setRows(listNew); 
		setShowConfirm(false); 
		var total = 0;
		var totalQty = 0;
		listNew.forEach(function(item){
			total += item.totpri;
			if (!isNonInventoryRow(item)) {
				totalQty += toQty(item.checkinqty);
			}
		});
		setGrandTotal(total);
		setTotalQty(totalQty);
		setAddItem(false);
	}; 

	// Handle the case of delete confirmation 
	// where user click no 
	const handleNo = () => { 
		setShowConfirm(false); 
	}; 

	const refreshCheckInItemCatalog = React.useCallback(() => {
		let accessToken = getAccessToken();
		try {
			const sessionUser = JSON.parse(sessionStorage.getItem('user'));
			accessToken = sessionUser?.accessToken || '';
		} catch (e) {
			// ignore
		}
		return apiClient
			.get(`/api/get/item`, checkInItemCatalogRequestConfig(accessToken))
			.then((res) => {
				setApiItemData(res.data || []);
			});
	}, []);

	useEffect(() => {
		refreshCheckInItemCatalog();
		const onVisible = () => {
			if (document.visibilityState === 'visible') {
				refreshCheckInItemCatalog();
			}
		};
		window.addEventListener('focus', refreshCheckInItemCatalog);
		document.addEventListener('visibilitychange', onVisible);
		return () => {
			window.removeEventListener('focus', refreshCheckInItemCatalog);
			document.removeEventListener('visibilitychange', onVisible);
		};
	}, [location.key, refreshCheckInItemCatalog]);

	const closeTransDetailDialog = () =>{
		setshowTranDetail(false);
  setformData({
				date: new Date(),
				action: '',
		        vendorId: null,
	    });
	
		setRows([]);
		setGrandTotal(0);
		setTotalQty(0);
		refreshCheckInItemCatalog();
	};

	
   const handleChange = (event) => {
		if (tranAction === 'edit' && event.target.name === 'vendorId') return;
        formData[event.target.name] = event.target.value;
        setformData({
            date: formData.date,
			action: formData.action,
            vendorId: formData.vendorId,
			reason: formData.reason
    });
    };

	const rowHasSelectedItem = (row) => {
		const id = row.itemid;
		return id != null && id !== '' && Number(id) > 0;
	};

	const flashCheckInError = (msg) => {
		setTimeout(() => {
			setErrorMessage(msg);
		}, 1000);
		setTimeout(() => {
			setErrorMessage(null);
		}, 10000);
	};

	const submit = (rowsOverride) => {
		var vendorName = '';
		const submitRows = rowsOverride || rows;

		if (submitRows.length === 0) {
			flashCheckInError('Please check and select the following: Order cannot be empty.');
			return;
		}

		const emptyItemIndex = submitRows.findIndex((row) => !rowHasSelectedItem(row));
		if (emptyItemIndex !== -1) {
			flashCheckInError(
				`Please select an item for row ${emptyItemIndex + 1}. Every line must have a valid item before submitting.`
			);
			return;
		}

		const seenItemNumberRows = {};
		const duplicateItemNumberIndex = submitRows.findIndex((row, idx) => {
			const normalizedItemNumber = String(row.itemnumber ?? '').trim().toLowerCase();
			if (!normalizedItemNumber) {
				return false;
			}
			if (seenItemNumberRows[normalizedItemNumber] != null) {
				return true;
			}
			seenItemNumberRows[normalizedItemNumber] = idx;
			return false;
		});
		if (duplicateItemNumberIndex !== -1) {
			const duplicateItemNumber = submitRows[duplicateItemNumberIndex]?.itemnumber;
			const firstRowIndex = seenItemNumberRows[String(duplicateItemNumber ?? '').trim().toLowerCase()];
			flashCheckInError(
				`Duplicate item number "${duplicateItemNumber}" found in rows ${firstRowIndex + 1} and ${duplicateItemNumberIndex + 1}. Please keep each item number unique.`
			);
			return;
		}

		if (tranAction !== 'return') {
			const zeroQtyIndex = submitRows.findIndex((row) => !(parseFloat(row.checkinqty) > 0));
			if (zeroQtyIndex !== -1) {
				flashCheckInError(
					`Quantity must be greater than zero for row ${zeroQtyIndex + 1}.`
				);
				return;
			}
		}

		const editStockRes = validateAllCheckInEditStock(submitRows);
		if (!editStockRes.ok) {
			flashCheckInError(editStockRes.message);
			return;
		}

		if (!(formData.vendorId > 0 && formData.action !== '')) {
			var errorMsg = 'Please check and select the following, ';

			if (formData.action === '') {
				errorMsg += 'Type of Transaction under "Select Action", \r\n';
			}
			if (!(formData.vendorId > 0)) {
				errorMsg += 'Vendor cannot be empty. \r\n';
			}

			flashCheckInError(errorMsg);
			return;
		}

		setloading(true);
		let user = JSON.parse(sessionStorage.getItem('user'));
		let accessToken = user.accessToken;
		let userId = user.userId;

		vendorName = (apiVendorData.filter((x) => x.VendorId == formData.vendorId)[0]).VendorName;
		const defaultLocId = getDefaultLocationId();
		const normalizeCheckInRow = (row) =>
			normalizeCheckInRowForSubmit(row, defaultLocId, apiLocationData);
		const rowsForSubmit = submitRows.map(normalizeCheckInRow);
		var data = {
			oldItemData: oldRows.map(normalizeCheckInRow),
			itemData: rowsForSubmit,
			date: moment(formData.date).format('MM-DD-YYYY'),
			vendorId: formData.vendorId,
			action: formData.action,
			customerName: vendorName,
			userId: userId,
			ticketNumber: tranEdit?.TicketNumber,
			reason: formData?.reason,
			tranAction: tranAction,
		};

		apiClient
			.post(`/api/post/transactionCheckIn`, { data }, { headers: { Authorization: `Bearer ${accessToken}` } })
			.then((res) => {
				refreshCheckInItemCatalog();

				setTimeout(() => {
					setSuccessMessage('Successfully submitted!');
				}, 1000);

				setTimeout(() => {
					setSuccessMessage(null);
					setloading(false);
					settranDetail({
						items: rows,
						TotalTicketPrice: grandTotal,
						TicketNumber: res.data.data,
						PONumber: '',
						Date: new Date(),
						UserName: '',
						VendorName: vendorName,
						CustomerName: vendorName,
						VendorId: formData.vendorId,
						CustomerId: formData.customerId,
					});
					setshowTranDetail(true);
					props.onSendValue();
				}, 2000);
			})
			.catch((error) => {
				setloading(false);
				const message = error?.response?.data?.error || 'Unable to update the ticket.';
				setErrorMessage(message);
				setTimeout(() => setErrorMessage(null), 5000);
			});
	};

	const checkEnoughStock = async () => {
		let accessToken = getAccessToken();
		try {
			const user = JSON.parse(sessionStorage.getItem('user'));
			accessToken = user?.accessToken || '';
		} catch (e) {
			// ignore
		}

		const result = await validatePurchaseOrderReturnLocationStock(
			rows,
			apiLocationData,
			accessToken
		);

		if (!result.ok) {
			flashCheckInError(result.errors.join('\n'));
			return;
		}

		if (result.needsConfirm) {
			const rowsWithAllocations = applyOtherLocationReturnAllocations(
				rows,
				apiLocationData
			);
			setPendingReturnRows(rowsWithAllocations);
			setReturnLocationConfirmMessage(result.confirmMessage);
			setShowReturnLocationConfirm(true);
			return;
		}

		setPendingReturnRows(null);
		submit();
	};

	const handleReturnLocationConfirmYes = () => {
		setShowReturnLocationConfirm(false);
		const rowsToSubmit = pendingReturnRows || rows;
		if (pendingReturnRows) {
			setRows(pendingReturnRows);
			setPendingReturnRows(null);
		}
		submit(rowsToSubmit);
	};

	const handleReturnLocationConfirmNo = () => {
		setShowReturnLocationConfirm(false);
		setPendingReturnRows(null);
	};

    const handleSubmit = () => {
		
		if(tranEdit == null)
		{
			formData.action =(pageName == 'intake' ? 'CheckIn' :'Return') ;
			submit();
		}else{
			if((formData?.reason != null && formData?.reason != '') || tranAction =='return' || tranAction =='return-order')
			{
                if(tranAction == 'return')
				{
					checkEnoughStock();
				}else{
					submit();
				}

				
			}else{
				setTimeout(() => {
					setErrorMessage('Please provide reason for transaction edit.');
				}, 1000);
				 
				setTimeout(() => {
				  setErrorMessage(null); 
				}, 10000);
			}
		}
		
		
       
        
    };
	const getTransactionType = (TicketNumber) =>{

if(TicketNumber != undefined)
{
	if(TicketNumber.includes('OUT'))
	{
return 'Invoice';
	}
	else if(TicketNumber.includes('CHK'))
	{
		return  'Purchase Order';
	}
	else if(TicketNumber.includes('RET'))
	{
		return  'Product Return';
	}
	else if(TicketNumber.includes('RES'))
	{
		return 'Product Reserves';
	}
	else if(TicketNumber.includes('ADJ'))
	{
		return 'Product Adjustments';
	}
}else{
	return '';
}
		
	  
	  };

	  const handlefocusOut = (e, index) => {
		setDisable(false); 
		const { name, value } = e.target; 
		const list = [...rows]; 
		list[index][name] = value; 

		

			if(name == 'checkinqty')
		{

			if( tranAction?.indexOf('return') != -1)
			{
				if( parseFloat(value) > parseFloat(list[index]['checkoutqty']) )
					{
						list[index][name] = list[index]['checkoutqty']; 
						setErrorMessage('selected return item should be less or equal to .' + parseFloat(list[index]['checkoutqty']));
					
					setTimeout(() => {
						setErrorMessage(null); 
						
					}, 2000);
				
					}
			} else if (
				isCheckInPurchaseOrderEditContext(tranAction, formData.action) ||
				tranEdit == null
			) {
				if (shouldValidateCheckInEditStock()) {
					const parsedQty = parseFloat(list[index].checkinqty);
					if (!Number.isNaN(parsedQty)) {
						const { clamped, message } = clampCheckInQtyToStock(list, index);
						if (clamped) {
							flashCheckInStockError(message);
						}
					}
				}
				Object.assign(
					list[index],
					syncCheckInLocationAllocationsToQty(
						list[index],
						list[index].checkinqty,
						apiLocationData
					)
				);
				setRows(list);
			}
			
		
		}
        
		
	}; 


	

	const handleChildChange = () => {
		setAddItem(false);
		refreshCheckInItemCatalog();
	};

	

return ( 

	
	<div className="CheckIn">
		<h2>
		{tranEdit == null?(
			pageName == 'intake' ?'Purchase Order' + (tranAction =='edit'?' Edit': tranAction =='return'?' Return':''): 'Product Return'
		):(
            formData.action == 'CheckIn'?'Purchase Order' + (tranAction =='edit'?' Edit': tranAction =='return'?' Return':'') :formData.action == 'CheckIn'? ' Create Purchase Order': 'Product Return'
		)
		}
		
	
	</h2>
	<TableBody> 
	<Snackbar 
		open={open} 
		autoHideDuration={2000} 
		onClose={handleClose} 
		className={classes.snackbar}> 
		<Alert onClose={handleClose} severity="success"> 
		Record saved successfully! 
		</Alert> 
	</Snackbar> 
	<Box margin={1}> 
		<TableRow align="center"></TableRow> 
		
		
		<div >
		{tranAction == 'return'  ? ( <div>
			<div>  { (tranAction =='return'?' Return ': '') + 'Ticket Number : ' + formData.ticketNumber}</div>
			<div>Transaction Type : {formData.action}</div>
			<div>Vendor Name : {formData.vendorName}</div>
			<div>User : {formData.user}</div>
			<div><FormControl  margin="normal">
				<MuiPickersUtilsProvider utils={DateFnsUtils}>
					<DatePicker
						label="Select Return Date"
						name="date"
						format="MM/dd/yyyy"
						value={formData.date}
						onChange={handleDateChange}
						displayEmpty
						margin="normal"
					/>
					</MuiPickersUtilsProvider>
				</FormControl></div>
		</div>)
	:
	(
		<div >
			{(tranAction == 'edit' && getTransactionType(formData.ticketNumber) == 'Product Return') && 
			(
				<div>
 					{'Return Ticket Number : ' + formData.returnTicketNumber }
				</div>
			)
			}
			<div>
				<FormControl  margin="normal">
				<MuiPickersUtilsProvider utils={DateFnsUtils}>
					<DatePicker
						label="Select Order Date"
						name="date"
						format="MM/dd/yyyy"
						value={formData.date}
						onChange={handleDateChange}
						displayEmpty
						margin="normal"
					/>
					</MuiPickersUtilsProvider>
				</FormControl>
			</div>
			<div>
					<FormControl  margin="normal">
					{(tranEdit == null || formData.vendorId == null) && ( <InputLabel id="select-label">Vendor</InputLabel>)} 
					
						<Select
								label="Vendor"
								name="vendorId" 
								value={formData.vendorId}
								onChange={(e) => handleChange(e)}
								disabled={tranAction === 'edit'}
								placeholder="Vendor"
								margin="normal"
								inputProps={{ 'aria-label': 'Without label' }} >
								<MenuItem value=''>  select Vendor</MenuItem>
								<MenuItem value=''> </MenuItem>
								{apiVendorData.map((item) => (
								<MenuItem value={item.VendorId}>  {item.VendorName}</MenuItem>
								))}
						</Select>  
				</FormControl>

			</div>
			
			

		{tranEdit != null &&(
		<div >
			
			<TextField  
			 multiline
			 rows={4} // Specify the number of visible rows
			 rowsMax={10} // Specify the maximum number of rows
			label="reason"
			
			className={classes.customTextField}
			variant="filled"
		
			InputLabelProps={{
				style: { width: '200px', textAlign: 'left' },
			}}
			name="reason"
			value={formData.reason}
			onChange={(e) => handleChange(e)}
		/>
	
	</div>
	)}	
			</div>

			
		
	)	
	} 
			
	
			<div >
			</div>
		
	
			<div style={{ display: "flex", justifyContent: "space-between", marginTop:"20px" }}> 

			{(tranAction == undefined || tranAction?.indexOf('return') == -1)  && 
			(
				<div> 

		<div className="alignDiv">
				<Button onClick={handleAdd}> 
				<AddBoxIcon onClick={handleAdd} /> 
				ADD 
				</Button> 
				</div>
				<div className="alignDiv">
				<Button onClick={handleAddItem}> 
				<AddBoxIcon onClick={handleAddItem} /> 
				ADD NEW ITEM
				</Button> 
				</div>
		</div> 
			)

			}
		
		
		</div> 
		<div
			style={{ marginTop: '10px' }}
			className={embeddedInDialog ? 'transaction-edit-grid' : undefined}
		>
		<Table 
			className={tableClassName} 
			size="small"
			aria-label="a dense table"
			> 
		<TableHead> 
			<TableRow className={classes.tableHeader} > 
			<TableCell className={tableCellClass} >Item Number</TableCell> 
			<TableCell className={tableCellClass}  align="center">Item Name</TableCell> 
			<TableCell className={tableCellClass}  align="center">Qty In Stock</TableCell> 
			<TableCell className={tableCellClass}  align="center">Qty</TableCell> 
			<TableCell className={tableCellClass}  align="center">Location</TableCell> 
			<TableCell className={tableCellClass}  align="center">Price per unit</TableCell> 
			<TableCell className={tableCellClass}  align="center">Target price</TableCell>
			<TableCell className={tableCellClass}  align="center">Total Price</TableCell> 
			<TableCell className={tableCellClass}  align="center"></TableCell> 
			</TableRow> 
		</TableHead> 
		<TableBody> 
			{rows.map((row, i) => {   
			return ( 
				
				<TableRow className={classes.tableRow} > 
					
						{isEdit ? ( 
						<TableCell className={tableCellClass}    component="th" scope="row"> 

{(tranAction == undefined || tranAction?.indexOf('return') == -1) ?
			(
				<Autocomplete
						id="itemid"
						name="itemid"
						limitTags={2}
						autoSelect={false}
						inputValue={row.itemnumber}
						options={apiItemData}
						onInputChange={(event, newValue, reason) => {
							
							handleInput2Change(event, newValue, i, reason);
						
						  }}
						onChange={(event, newValue, reason) => {
							if (reason === 'select-option' && newValue && typeof newValue === 'object') {
								const list = [...rows];
								applyCheckInGridItem(list, i, newValue).then((updated) => {
									setRows([...updated]);
									recomputeTotalsFromList(updated);
								});
								return;
							}
								handleAutoCompleteChange(event,i,reason);
						
						  }}
						 
						  onBlur={(event, newValue, reason) => {
							
								handleAutoCompleteBlur(event,i,reason);
						
						  }}
						 
						
						getOptionLabel={(option) => getItemGridOptionLabel(option)}
						filterOptions={filterItemGridOptions}
						style={{
							minWidth: embeddedInDialog ? 0 : 220,
							width: embeddedInDialog ? '100%' : undefined,
							maxWidth: embeddedInDialog ? '100%' : undefined,
							border: null,
						}}
						renderInput={(params) => (
							<TextField {...params} variant="standard" placeholder="Number or name…" />
						)}
						
						/>
			):(
				row.itemnumber

			)}
						
					
						</TableCell> 
						):(
						<TableCell className={tableCellClass}  component="th" scope="row"> 
						{row.item} 
						</TableCell> 
						)}

						{isEdit ? ( 
						  <TableCell padding="none"> 
                          <input 
						  disabled
						   type="text"
                            value={row.itemname} 
                            name="itemname"
                            onChange={(e) => handleInputChange(e, i)} 
                          /> 
                        </TableCell> 
						):(
							<TableCell className={tableCellClass}  component="th" scope="row" align="center"> 
						{row.itemname} 
						</TableCell> 
						)}
						
						{isEdit ? ( 
						  <TableCell padding="none" style={{   textAlign:"right" }}> 
                          <input 
						  disabled
						  style={{   textAlign:"right" }}
						   type="Number"
                            value={row.qtyinstock} 
                            name="qtyinstock"
                            onChange={(e) => handleInputChange(e, i)} 
                          /> 
                        </TableCell> 
						):(
							<TableCell className={tableCellClass}  component="th" scope="row" align="right"> 
						{parseFloat(row.qtyinstock)?.toFixed(2)} 
						</TableCell> 
						)}

						
						{isEdit ? ( 
						  <TableCell padding="none" style={{   textAlign:"right" }}> 
                          <input 
                            value={row.checkinqty} 
							style={{   textAlign:"right" }}
							type="Number"
                            name="checkinqty"
							min={1}
                            onChange={(e) => handleInputChange(e, i)} 
							onBlur={(e) => handlefocusOut(e, i)} 
                          /> 
                        </TableCell> 
						):(
							<TableCell className={tableCellClass}  component="th" scope="row" align="right"> 
						{parseFloat(row.checkinqty)?.toFixed(2)} 
						</TableCell> 
						)}

						{isEdit ? ( 
						  <TableCell padding="none" style={{ textAlign:"left" }}> 
							<FormControl fullWidth size="small">
								<Select
									name="locationId"
									value={row.locationId == null ? '' : row.locationId}
									onChange={(e) => handleInputChange(e, i)}
									displayEmpty
									disabled={isNonInventoryRow(row)}
									inputProps={{ 'aria-label': 'Location' }}
								>
									<MenuItem value=''>
										{isNonInventoryRow(row) ? 'N/A' : 'Select Location'}
									</MenuItem>
									{apiLocationData.map((loc) => (
										<MenuItem key={`loc-${loc.ItemLocationId}`} value={loc.ItemLocationId}>
											{loc.LocationName}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						  </TableCell> 
						):(
							<TableCell className={tableCellClass} component="th" scope="row" align="left"> 
								{(apiLocationData.find((l) => Number(l.ItemLocationId) === Number(row.locationId)) || {}).LocationName || ''}
							</TableCell> 
						)}

{isEdit ? ( 
						  <TableCell padding="none" style={{   textAlign:"right" }}> 
						  {(tranAction == undefined || tranAction?.indexOf('return') == -1) ?
			(
				<input 
				value={row.priperunit} 
				type="Number"
				name="priperunit"
				style={{   textAlign:"right" }}
				min={1}
				onChange={(e) => handleInputChange(e, i)} 
			  /> 
			):(
				row.priperunit
			)}
                        
                        </TableCell> 
						):(
							<TableCell className={tableCellClass}  component="th" scope="row" align="right"> 
						{row.priperunit} 
						</TableCell> 
						)}

						{isEdit ? ( 
						  <TableCell padding="none" style={{   textAlign:"right" }}> 
						  {(tranAction == undefined || tranAction?.indexOf('return') == -1) ?
			(
				<input 
				value={row.targetprice} 
				type="Number"
				name="targetprice"
				style={{   textAlign:"right" }}
				min={0}
				step="0.01"
				onChange={(e) => handleInputChange(e, i)} 
			  /> 
			):(
				parseFloat(row.targetprice)?.toFixed(2)
			)}
                        </TableCell> 
						):(
							<TableCell className={tableCellClass}  component="th" scope="row" align="right"> 
						{parseFloat(row.targetprice)?.toFixed(2)} 
						</TableCell> 
						)}

{isEdit ? ( 
						  <TableCell padding="none" style={{   textAlign:"right" }}> 
                          {row.totpri.toLocaleString()} 
                        </TableCell> 
						):(
							<TableCell className={tableCellClass} style={{   textAlign:"right" }}  component="th" scope="row" align="center"> 
						{row.totpri.toLocaleString()} 
						</TableCell> 
						)}

		
	<TableCell  className={tableCellClass} 
						component="th"
						scope="row"
						align="center"
						>
							{(tranAction == undefined || tranAction?.indexOf('return') == -1)  && 
			(
<Button className="mr10" onClick={(e) =>handleConfirm(row.id)}> 
									<DeleteOutlineIcon /> 
								</Button> 
			)}
							
								
								
							
							</TableCell> 

					
					
					
					{showConfirm && ( 
					<div> 
						<Dialog 
						open={showConfirm} 
						onClose={handleNo} 
						aria-labelledby="alert-dialog-title"
						aria-describedby="alert-dialog-description"
						> 
						<DialogTitle id="alert-dialog-title"> 
							{"Confirm Delete"} 
						</DialogTitle> 
						<DialogContent> 
							<DialogContentText  > 
							Are you sure to delete
							</DialogContentText> 
						</DialogContent> 
						<DialogActions> 
							<Button 
							onClick={() => handleRemoveClick()}
							color="primary"
							autoFocus 
							> 
							Yes 
							</Button> 
							<Button 
							onClick={handleNo} 
							color="primary"
							autoFocus 
							> 
							No 
							</Button> 
						</DialogActions> 
						</Dialog> 
					</div> 
					)} 
				</TableRow> 
				
			); 
			})} 
		</TableBody> 
		</Table> 

		</div>
		<div className="alignRightDiv" style={{  marginTop:"30px" ,  textAlign:"right", marginRight:"60px" }}>
			<h3>Grand Total: ${grandTotal?.toLocaleString()}</h3>
		</div>
		<div className="alignRightDiv" style={{  marginTop:"30px" ,  textAlign:"right", marginRight:"60px" }}>
			<h3> Total Quantity: { tranEdit != undefined? getTotalQuantityEditMode()?.toLocaleString():totalQty?.toLocaleString() }</h3>
		</div>
		
       <br></br>
       <div style={{ textAlign:"center", marginTop:"40px" }}>
		<Button type="button" onClick={handleSubmit} variant="contained" color="primary" >
			Submit
			</Button>
	   </div>  
	   {successMessage && (
        <div style={{ backgroundColor: '#28a745', color: '#fff', padding: '10px', marginTop: '10px' }}>
          {successMessage}
        </div>
      )}

{errorMessage && (
        <div style={{ backgroundColor: '#FF7F7F', color: '#fff', padding: '10px', marginTop: '10px', whiteSpace: 'pre-line' }}>
          {errorMessage}
        </div>
      )}

{showReturnLocationConfirm && (
					<Dialog
						open={showReturnLocationConfirm}
						onClose={handleReturnLocationConfirmNo}
						aria-labelledby="return-location-confirm-title"
					>
						<DialogTitle id="return-location-confirm-title">
							Return quantity from other locations
						</DialogTitle>
						<DialogContent>
							<DialogContentText style={{ whiteSpace: 'pre-line' }}>
								{returnLocationConfirmMessage}
								{'\n\n'}
								Do you want to continue?
							</DialogContentText>
						</DialogContent>
						<DialogActions>
							<Button onClick={handleReturnLocationConfirmYes} color="primary">
								Yes, continue
							</Button>
							<Button onClick={handleReturnLocationConfirmNo} color="primary">
								Cancel
							</Button>
						</DialogActions>
					</Dialog>
				)}
   
      </div>	
	</Box> 
	</TableBody> 

	{showAddItem && ( 
					<div> 
						<Dialog  
						  fullWidth={fullWidth}
						  maxWidth={maxWidth}
						open={showAddItem} 
						onClose={() => setAddItem(false)} 
						
						> 
						<DialogTitle id="alert-dialog-title"> 
						<div className={classes.divLeft}>
						{"Add New Item"} 
						</div>
						<div className={classes.divRight}>
						<IconButton
								aria-label="close"
								onClick={() => setAddItem(false)}
								sx={{
									position: "absolute",
									right: 8,
									top: 8,
									color: (theme) => theme.palette.grey[500]
								}}
								>
								<CloseIcon />
								</IconButton>
						</div>
							
							
						</DialogTitle> 
						<DialogContent> 
							<DialogContentText id="alert-dialog-description"> 
							<ItemForm    onSendValue={() => handleChildChange()}  />
							</DialogContentText> 
						</DialogContent> 
						<DialogActions> 
							
							
						</DialogActions> 
						</Dialog> 
					</div> 
					)}


			
{showTranDetail && ( 
					<div> 
						<Dialog  
						  fullWidth={fullWidthTrans}
						  maxWidth={maxWidthTrans}
						open={showTranDetail} 
						onClose={() => closeTransDetailDialog()} 
						style={{ height: '800px' }}
						> 
            <DialogTitle id="alert-dialog-title"> 
						<div style={{float:"left"}}>
            <IconButton
								aria-label="download"
								onClick={() => generatePdf()}
								sx={{
									position: "absolute",
									right: 8,
									top: 5,
									color: (theme) => theme.palette.grey[500]
								}}
								>
								 <CloudDownloadIcon />
								</IconButton>
					
						</div>
						<div style={{float:"right"}}>
						<IconButton
								aria-label="close"
								onClick={() => closeTransDetailDialog()}
								sx={{
									position: "absolute",
									right: 8,
									top: 5,
									color: (theme) => theme.palette.grey[500]
								}}
								>
								<CloseIcon />
								</IconButton>
						</div>
							
							
						</DialogTitle> 
					
						<DialogContent  ref={contentRef} id="alert-dialog-description"> 
							<DialogContentText > 
             <h2 style={{textAlign:"center"}} >Transaction Detail</h2>
			  <TransactionHeader
				ticketNumber={tranDetail.TicketNumber}
				recipientName={tranDetail.VendorName || tranDetail.CustomerName}
				date={moment(formData.date).format('MM-DD-YYYY')}
				userName={userName}
			  />
							<TableContainer>

					<div   ref={gridRef}
            style={{
              height: "300px", // Restrict height to make it scrollable
              overflow: "auto"
            }}
>
<Table>
                    <TableHead>
                      <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell style={{ fontWeight: 600, fontSize: '14px', color: 'rgba(0,0,0,0.87)' }}>Item Number</TableCell>
                        <TableCell style={{ fontWeight: 600, fontSize: '14px', color: 'rgba(0,0,0,0.87)' }}>Item Name</TableCell>
                        <TableCell style={{ fontWeight: 600, fontSize: '14px', color: 'rgba(0,0,0,0.87)', textAlign: 'right' }}>Quantity</TableCell>
                        <TableCell style={{ fontWeight: 600, fontSize: '14px', color: 'rgba(0,0,0,0.87)', textAlign: 'right' }}>Price</TableCell>
                        <TableCell style={{ fontWeight: 600, fontSize: '14px', color: 'rgba(0,0,0,0.87)', textAlign: 'right' }}>Target price</TableCell>
                        <TableCell style={{ fontWeight: 600, fontSize: '14px', color: 'rgba(0,0,0,0.87)', textAlign: 'right' }}>Total</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tranDetail.items.map(item => (
                        <TableRow >
                          <TableCell>{item.itemnumber}</TableCell>
                          <TableCell>{item.itemname}</TableCell>
                          <TableCell style={{  textAlign:"right"}}>{item.checkinqty}</TableCell>
                          <TableCell style={{  textAlign:"right"}}>${item.priperunit.toLocaleString()}</TableCell>
                          <TableCell style={{  textAlign:"right"}}>${parseFloat(item.targetprice ?? 0)?.toLocaleString()}</TableCell>
                          <TableCell style={{  textAlign:"right"}}>${item.totpri.toLocaleString()}</TableCell>
                          
                        </TableRow>
                      ))}
                    </TableBody>
                    <TableFooter style={{ height: '100%'}} >
                    <TableRow>
                        <TableCell style={{ borderBottom: '0px none'}}></TableCell>
                        <TableCell style={{ borderBottom: '0px none'}}></TableCell>
                        <TableCell style={{ borderBottom: '0px none'}}></TableCell>
                        <TableCell style={{ borderBottom: '0px none'}}></TableCell>
                        <TableCell style={{ borderBottom: '0px none',fontStyle:"normal", fontSize:"16px", textAlign:"right"}}><b>Grand Total :</b></TableCell>
                        <TableCell style={{ borderBottom: '0px none',fontStyle:"normal", fontSize:"16px", textAlign:"right"}}> <b>${tranDetail.TotalTicketPrice.toLocaleString()}</b></TableCell>
                      </TableRow>

					  <TableRow>
                        <TableCell style={{ borderBottom: '0px none'}}></TableCell>
                        <TableCell style={{ borderBottom: '0px none'}}></TableCell>
                        <TableCell style={{ borderBottom: '0px none'}}></TableCell>
                        <TableCell style={{ borderBottom: '0px none'}}></TableCell>
                        <TableCell style={{ borderBottom: '0px none',fontStyle:"normal", fontSize:"16px", textAlign:"right"}}><b>Total Quantity :</b></TableCell>
                        <TableCell style={{ borderBottom: '0px none',fontStyle:"normal", fontSize:"16px", textAlign:"right"}}> <b>{getTotalQuantity()?.toLocaleString()}</b></TableCell>
                      </TableRow>
                      

                    </TableFooter>
                  </Table>
					</div>
                 
                  <br/>
                  <br/>
                 
                </TableContainer>
							</DialogContentText> 
						</DialogContent> 
						<DialogActions> 
							
							
						</DialogActions> 
						</Dialog> 
            
					</div> 
					)} 
					{loading ? <Spinner /> :""}

	</div>
); 
} 

export default CheckIn;
